import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import { radiosComponent } from "../../forms/customInput";
import ButtonTooltip from "../ButtonTooltip/ButtonTooltip";
import "./questionnaire.css";
import PropTypes from "prop-types";

const Questionnaire = ({
  id,
  radioQuestion,
  options,
  name,
  handleOnClick,
  value,
  desc,
  tooltip,
  disabledOptions,
  optionsTooltip,
}) => {
  const [showList, setShowList] = useState(false);

  const showAndHide = () => {
    setShowList(!showList);
  };

  return (
    <div className="question-wrapper">
      <div id={id} className="question-title">
        {radioQuestion}
        {tooltip && (
          <ButtonTooltip
            className={tooltip.className}
            content={tooltip.content}
          />
        )}
      </div>
      <div className="radio-options-wrapper">
        <Formik>
          <Form>
            {options.map((item, index) => {
              const isDisabledButtonTooltip = optionsTooltip && disabledOptions?.includes(item);
              return (
                <div key={name + "_option_" + index} className={isDisabledButtonTooltip ? "radio-disabled-tooltip" : ""}>
                  <Field
                    key={name + "_option_" + index}
                    id={item.replace(/ /g, "_")}
                    customName={name}
                    radioText={item}
                    onClick={() => handleOnClick(item)}
                    isChecked={value === item}
                    component={radiosComponent}
                    dataTestId={name + "_option_" + index}
                    disabled={disabledOptions?.includes(item)}
                  />
                    {isDisabledButtonTooltip && 
                    <ButtonTooltip 
                      className={optionsTooltip.className}
                      content={optionsTooltip.content}
                      theme="bentley"
                    />}
                </div>
              );
            })}
          </Form>
        </Formik>
      </div>

      <div>
        {desc && (
          <>
            <a
              data-testid="learn-more-link"
              onClick={() => showAndHide()}
              className={
                showList ? "learn-more-holder learn-open" : "learn-more-holder"
              }
              href
            >
              Learn More
            </a>
            {showList ? (
              <>
                <div className="learn-more-inner">
                  <p> {desc}</p>
                </div>
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </div>
  );
};

Questionnaire.propTypes = {
  id: PropTypes.string.isRequired,
  radioQuestion: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  value: PropTypes.string,
  desc: PropTypes.string,
  tooltip: PropTypes.shape({
    className: PropTypes.string,
    content: PropTypes.string,
  }),
  disabledOptions: PropTypes.arrayOf(PropTypes.string),
  optionsTooltip: PropTypes.shape({
    className: PropTypes.string,
    content: PropTypes.string,
  }),
};

export default Questionnaire;
